import { useEffect } from 'react';
import { type BrandConfig } from '@/config/branding';
import { applyBrandFavicon } from '@/lib/branding/favicon';
import { useEffectiveBranding } from '@/hooks/use-effective-branding';
import { applyPrimaryColorToDocument } from '@/lib/branding/apply-primary-color';
import { applyBrandFontToDocument } from '@/lib/branding/apply-brand-font';

/**
 * Hook to apply brand theme colors to CSS variables.
 *
 * Accepts an optional brand override - useful on the primary's sign-in
 * page when a partner's satellite redirected here with `?redirect_url=`,
 * so the hop is visually partner-branded instead of showing tagada.
 */
export function useBrandTheme(override?: BrandConfig | null) {
  const ambient = useEffectiveBranding();
  const brand = override ?? ambient;
  const { primaryColor, favicon, appName, fontFamily } = brand;

  useEffect(() => {
    if (primaryColor) applyPrimaryColorToDocument(primaryColor);
    applyBrandFavicon(favicon, appName, primaryColor);
    applyBrandFontToDocument(fontFamily);
  }, [primaryColor, favicon, appName, fontFamily]);
}
